import {doc} from './docs.js';
import {
    setZObjectProgressBar,
    setZObjectModal} from 'actions/index.js';

doc(
    "modal",
    {
        "show": "1 to show 0 to hide",
        "text": "The main text (arrays are seperated by lines)",
        "ok button text": "",
        "cancel button text": "",
        "link text": "",
        "link url": "",
    },
    "Creates a modal",
    () => 2,
    {
        inlets: 6
    });

export const modal = (
    object,
    text,
    okButtonText,
    cancelButtonText,
    linkText,
    linkUrl) => {
    return ([show]) => {
        if (show) {
            // set the redux state with this (object, text, okTexzt, cancelText)
            let link = undefined;
            let _linkText = linkText();
            let _linkUrl = linkUrl();
            if (Array.isArray(_linkText)) {
                link = [];
                for (let i=0; i < _linkText.length; i++) {
                    link.push({
                        text: _linkText[i],
                        url: _linkUrl[i]
                    });
                }
            } else if (_linkText && _linkUrl) {
                link = {
                    text: _linkText,
                    url: _linkUrl
                };
            }
            object.dispatch(setZObjectModal({
                zobject: object,
                text: text(),
                link,
                okButtonText: okButtonText(),
                cancelButtonText: cancelButtonText()
            }));
        } else {
            // set the redux state to undefined
            object.dispatch(setZObjectModal(undefined));
        }
    };
};

doc(
    "progressbar",
    {
        "start/stop": "",
        "text": "",
    },
    "Shows a progressbar spinner",
    () => 0,
    {
        inlets: 2
    }
);

export const progressbar = (object, text) => {
    return ([show]) => {
        if (show) {
            object.dispatch(
                setZObjectProgressBar(text()));
        } else {
            object.dispatch(
                setZObjectProgressBar(undefined));
        }
    };
};
